import { LeaveTypeCreate } from './LeaveTypeCreate';
import { LeaveTypeEdit } from './LeaveTypeEdit';
import { LeaveTypeList } from './LeaveTypeList';

export default {
    create: LeaveTypeCreate,
    edit: LeaveTypeEdit,
    list: LeaveTypeList
}